const doc = [({"en":({"js":({"admin":({"photos":({"table":({"photo":"Photo", "the_photo_type_on_the_photo_was_saved":"The photo type on the photo was saved."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;